import { styled } from '@mui/system';
import PreloaderComponent from '#component/preloader';

export const StyledPeloaderComponent = styled(PreloaderComponent)(() => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  margin: '-40px 0 0 -40px'
}));
